import { render, staticRenderFns } from "./OkrCadastro.vue?vue&type=template&id=4436ff28&"
import script from "./OkrCadastro.vue?vue&type=script&lang=js&"
export * from "./OkrCadastro.vue?vue&type=script&lang=js&"
import style0 from "./OkrCadastro.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports